class StoreVariantSelector {
  constructor(section) {
    this.section = section;
    this.selector = section.querySelector('[data-store-variant-selector]');
    if (!this.selector) return;

    this.options = this.selector.querySelectorAll('.store-variant-selector__option');
    this.priceDisplay = section.querySelector('.product-detail__price-sale');
    this.addToCartBtn = section.querySelector('.product-detail__register-btn');

    this.bindEvents();
  }

  bindEvents() {
    this.options.forEach((option) => {
      option.addEventListener('click', () => this.selectVariant(option));
    });
  }

  selectVariant(option) {
    // Update radio selection
    this.options.forEach((opt) => {
      opt.classList.remove('is-selected');
    });
    option.classList.add('is-selected');

    // Update price display
    const price = parseInt(option.getAttribute('data-store-variant-price'), 10);
    if (this.priceDisplay) {
      this.priceDisplay.textContent = '$' + (price / 100).toFixed(2);
    }

    // Update add to cart data
    const variantId = option.getAttribute('data-store-variant-id');
    if (this.addToCartBtn) {
      this.addToCartBtn.setAttribute(
        'data-selected-variants',
        JSON.stringify([{ id: variantId, quantity: 1 }])
      );
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.store-page-main-container').forEach((section) => {
    new StoreVariantSelector(section);
  });
});
